// src/hooks/useSessionExpired.js
import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const useSessionExpired = () => {
  const [isSessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const data = error?.response?.data;
        const msg = (error?.response?.data?.message || error?.message || '').toString().toLowerCase();

        if (
          status === 401 ||
          data?.status === 'error' ||
          msg.includes('expired') ||
          msg.includes('invalid token') ||
          msg.includes('token')
        ) {
          // mark expired (this will show popup in AppContent)
          setSessionExpired(true);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  // manual trigger used by components that detect expiry directly
  const handleSessionExpired = useCallback(() => {
    setSessionExpired(true);
  }, []);

  const closeSessionExpired = useCallback(() => {
    setSessionExpired(false);
  }, []);

  return {
    isSessionExpired,
    handleSessionExpired,
    closeSessionExpired,
    // expose setter too in case some code expects it
    setSessionExpired,
  };
};

export default useSessionExpired;
